var sliders = document.querySelectorAll('.blog-tabs-slider');
function refreshSlider(slider) {
  slider.slick('slickGoTo', 0);
  slider.slick('slickSetOption', null, null, true);
}

function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
     $('.blog-tabs-slider').slick('refresh');
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.classList.add("active");
   $('.blog-tabs-slider').slick('refresh');
  var slider = $(document.getElementById(tabName)).find('.slider');
  if (slider.length && slider.hasClass('slick-initialized')) {
    refreshSlider(slider);
  } else if (slider.length) {
    slider.slick();
  }
}

sliders.forEach(function(slider) {
  $(slider).slick({
     arrows: true,
    swipe: false,
    draggable: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
});

// Set the first tab as active by default


$('.featured-coll-slider').slick({
    arrows: true,
    swipe: false,
    draggable: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
});

$('.about_story_slider').slick({
    arrows: false,
    swipe: true,
    draggable: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 2000,
});

$('.timeline-list').slick({
    arrows: false,
    draggable: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
});

$('.about_action_img_slider').slick({
    arrows: false,
    swipe: true,
    dots:true,
    fade:false,
    draggable: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
});



$('.product-slider').slick({
    arrows: true,
    swipe: true,
    dots:true,
    fade:false,
    draggable: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
});


// FAQ Accordion
$('.accordion').find('.accordion-title').on('click', function() {
    $(this).toggleClass('active');
    $(this).next().slideToggle('fast');
    $('.accordion-content').not($(this).next()).slideUp('fast');
    $('.accordion-title').not($(this)).removeClass('active');
});

// Accordion Start
var acc = document.getElementsByClassName("faq-ques");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}




document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    method: 'click',
    offset: 1000
  });
});


setTimeout(function() {
mobileOnlySlider(".tranding-article-list", false, true,  992);
function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
		dots: $dots,
		arrows: $arrows,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick",
			},
            {
                breakpoint: 500,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                },
            }
		]
	};

	slider.slick(settings);
	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
}
}, 5000);